/* Sacola: "Adicione também", "Calcular frete" e "Cupom de desconto" recolhíveis.
   O estado fica em atributos no próprio <aside data-cart-drawer> (que nunca é
   recriado), porque o conteúdo interno é remontado a cada atualização do
   carrinho pelo global.js / buddy-cart-extras.
   Padrão: sugestões abertas; frete e cupom fechados.
   Listeners em fase de captura: o widget de frete/cupom para a propagação
   dos eventos de teclado. */
(function () {
  'use strict';
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || drawer.__cx) return;
  drawer.__cx = true;

  var TARGETS = {
    crec: '.crec__title',
    ship: '[data-bce-ship] > .bce-label',
    coupon: '[data-bce-coupon] > .bce-label'
  };

  drawer.setAttribute('data-cx-ship', '');
  drawer.setAttribute('data-cx-coupon', '');

  function sync() {
    Object.keys(TARGETS).forEach(function (key) {
      var expanded = String(!drawer.hasAttribute('data-cx-' + key));
      drawer.querySelectorAll(TARGETS[key]).forEach(function (el) {
        if (el.getAttribute('data-cx') !== key) {
          el.setAttribute('data-cx', key);
          el.setAttribute('role', 'button');
          el.setAttribute('tabindex', '0');
        }
        if (el.getAttribute('aria-expanded') !== expanded) el.setAttribute('aria-expanded', expanded);
      });
    });
  }

  function toggle(key) {
    drawer.toggleAttribute('data-cx-' + key);
    sync();
  }

  drawer.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-cx]');
    if (!el || !drawer.contains(el)) return;
    e.preventDefault();
    toggle(el.getAttribute('data-cx'));
  }, true);

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-cx]');
    if (!el) return;
    e.preventDefault();
    toggle(el.getAttribute('data-cx'));
  }, true);

  new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  sync();
})();
